var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "billing-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "1075px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-content", staticStyle: { height: "100%" } },
        [
          _c("div", { staticClass: "details-view" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      !_vm.currentRow.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "basicTab",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _c("basic-tab", {
                                ref: "basicTab",
                                attrs: { context: _vm.context, action: "look" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.currentRow.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "masterBasicTab",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _c("master-basic-tab", {
                                ref: "masterBasicTab",
                                attrs: { context: _vm.context, action: "look" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      (_vm.docType === "MAWB" &&
                        (_vm.currentRow.masterFlag ||
                          _vm.currentRow.operateType === 2 ||
                          _vm.currentRow.operateType === 3)) ||
                      _vm.docType === "HAWB"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                lazy: true,
                                name: "tabMAWB",
                                label: "MAWB"
                              }
                            },
                            [
                              _c("tab-mawb", {
                                ref: "tabMAWB",
                                attrs: { context: _vm.context, action: "edit" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.docType === "HAWB"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 4,
                              attrs: {
                                lazy: true,
                                name: "tabHAWB",
                                label: "HAWB"
                              }
                            },
                            [
                              _c("tab-hawb", {
                                ref: "tabHAWB",
                                staticStyle: { width: "1215px" },
                                attrs: { context: _vm.context, action: "edit" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _c(
        "span",
        {
          staticStyle: { display: "flex" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.printHandler(true)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.preprint")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["button_AERouteCentral_BillingPrint"],
                  expression: "['button_AERouteCentral_BillingPrint']"
                }
              ],
              attrs: { disabled: !_vm.btnEnabled.print, type: "primary" },
              on: {
                click: function($event) {
                  return _vm.printHandler()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Payment.print")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$store.getters.isAdmin,
                  expression: "$store.getters.isAdmin"
                }
              ],
              attrs: {
                disabled: !_vm.btnEnabled.rollbackPrint,
                type: "primary"
              },
              on: { click: _vm.rollbackPrintHandler }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.undoPrinting")))]
          ),
          _c(
            "span",
            {
              staticStyle: {
                "line-height": "30px",
                color: "blue",
                "margin-left": "10px"
              }
            },
            [_vm._v(_vm._s(_vm.state))]
          ),
          _c("div", { staticStyle: { "flex-grow": "1" } }),
          _c(
            "el-button",
            {
              attrs: { disabled: !_vm.btnEnabled.tempSave, type: "primary" },
              on: { click: _vm.saveHandler }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.temporaryStorage")))]
          ),
          _c(
            "el-button",
            {
              attrs: { disabled: !_vm.btnEnabled.save, type: "primary" },
              on: { click: _vm.commitHandler }
            },
            [_vm._v(_vm._s(_vm.btnSaveLable))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }